<template>
	<div>
		<v-container>
            <v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

            <v-card :loading="isEdit && loading" :disabled="isEdit && loading">
				<v-card-title>
					<template v-if="isEdit">
						تعديل على رتبة
					</template>
					<template v-else>
						إضافة رتبة جديدة
					</template>
				</v-card-title>

                <v-card-text>
					<v-form v-model="valid">
						<v-row justify="center" class="py-1">
							<v-col cols="12" class="py-1">
								<v-text-field v-model="newRecord.adRankID" label="معرف الرتبة" outlined hide-details="auto" :rules="[rules.required, rules.id]" :disabled="isEdit"></v-text-field>
							</v-col>
						
							<v-col cols="12" md="6" class="py-1">
								<v-text-field v-model="newRecord.name" label="اسم الرتبة" outlined hide-details="auto" :rules="[rules.required]"></v-text-field>
							</v-col>
						
							<v-col cols="12" md="6" class="py-1">
								<v-text-field v-model="newRecord.priority" label="الأولوية" outlined hide-details="auto" :rules="[rules.required, rules.number, rules.posNumber]"></v-text-field>
							</v-col>
						
							<v-col cols="12" md="6" class="py-1">
								<v-text-field v-model="newRecord.topPriority" label="أولوية ظهور الإعلان العلوي" outlined hide-details="auto" :rules="[rules.required, rules.number, rules.posNumber]"></v-text-field>
							</v-col>
						
							<v-col cols="12" md="6" class="py-1">
								<v-text-field v-model="newRecord.rightPriority" label="أولوية ظهور الإعلان الداخلي" outlined hide-details="auto" :rules="[rules.required, rules.number, rules.posNumber]"></v-text-field>
							</v-col>
						</v-row>


						<v-row justify="center" class="py-1">
							<v-col cols="12" class="text-center">
								<v-btn class="primary" :disabled="!valid" :loading="loading" @click="addnewRecord">
									<template v-if="isEdit">
										حفظ
									</template>
									<template v-else>
										إضافة
									</template>
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
                </v-card-text>
            </v-card>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
// import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الرتب', exact: true, to: { name: "dashboard-ranks" }},
				{ text: 'إضافة رتبة', disabled: true }
			],
			newRecord: {
				adRankID: null,
				name: null,
				priority: null,
				topPriority: null,
				rightPriority: null
			},
			valid: false,
			loading: false,

			isEdit: false,
			recordID: null
		};
	},
	mounted(){
		if (this.$route.params.recordID) {
			console.log("edit");
			this.isEdit = true;
			this.loading = true;
			this.recordID = this.$route.params.recordID;
			this.breadcrumbs[2].text = "التعديل";
			this.getRecord();
		} else {
			console.log("not edit");
		}
	},
	methods: {
		getRecord(){
			clientNotifier
				.get("/api/adranks/show/" + this.recordID)
				.then(response => {
					console.log(response);
					this.newRecord = response.data.data;
					this.loading = false;
				})
				.catch(err => {
					console.log(err);
				});
		},
		// getRecord() {
		// 	client
		// 		.get("/api/unspokenname/adranks")
		// 		.then((resoponse) => {
		// 			this.newRecord = resoponse.data.find(rank => rank.adRankID == this.recordID);
		// 			this.loading = false;
		// 		})
		// 		.catch((err) => {
		// 			console.log(err);
		// 		});
		// },
		addnewRecord() {
			if (this.isEdit) {
				this.updateRank();
			} else {
				this.insertRank();
			}
		},
		insertRank() {
			this.loading = true;
			var data = {
				...this.newRecord
			};
			clientNotifier
				.post("/api/adranks/insert", data)
				.then(() => {
					this.$router.push({ name: "dashboard-ranks-manage" });
				})
				.catch(() => {
					this.loading = false;
				});
		},
		updateRank(){
			this.loading = true;
			var data = {
				...this.newRecord
			};
			clientNotifier
				.post("/api/adranks/update", data)
				.then(() => {
					this.$router.push({ name: "dashboard-ranks-manage" });
				})
				.catch(() => {
					this.loading = false;
				});
		}
	}
};
</script>